// Traduce paths (URLs) a nombres humanos para paneles admin (Analytics, Reportes, etc.).
// Cubre limpack.uy (landing pública) + tienda.limpack.uy + panel.limpack.uy (cliente + admin).
//
// Fuente: rutas de App.jsx (Router) + deploy_v5/index.html (landing) al 20-jul-2026.
// Si agregás una ruta nueva, agregala acá también para que el nombre humano aparezca en analytics.

// ============================================================================
// Rutas EXACTAS (match directo)
// ============================================================================
const RUTAS_EXACTAS = {
  // ─── Sitio público (limpack.uy) ─────────────────────────────────
  '/': 'Home · Landing',
  '/index.html': 'Home · Landing',
  '/como-funciona': 'Cómo funciona',
  '/kits': 'Kits',
  '/empresas': 'Empresas',
  '/porteros': 'Porteros · Sé el primero',
  '/barrios': 'Barrios',
  '/faq': 'Preguntas frecuentes',
  '/privacidad': 'Política de privacidad',
  '/terminos': 'Términos y condiciones',
  '/cotizar': 'Cotizar B2B',
  '/quiero-ser-portero': 'Postulación portero',
  '/unsubscribe': 'Baja de emails',

  // ─── Tienda (tienda.limpack.uy) ─────────────────────────────────
  '/tienda': 'Tienda · Home',
  '/tienda/catalogo': 'Tienda · Catálogo',
  '/suscribirme': 'Wizard nueva suscripción',

  // ─── Auth (panel.limpack.uy) ────────────────────────────────────
  '/login': 'Login',
  '/reset-password': 'Reset password',
  '/set-password': 'Set password',
  '/activar-cuenta': 'Activar cuenta',
  '/auth/callback': 'OAuth callback',
  '/invitar': 'Invitación',

  // ─── Cliente (panel.limpack.uy/cliente/*) ───────────────────────
  '/cliente': 'Cliente · Home',
  '/cliente/inicio': 'Cliente · Inicio',
  '/cliente/mi-plan': 'Cliente · Mi plan',
  '/cliente/cuenta': 'Cliente · Mi cuenta',
  '/cliente/cargar-tarjeta': 'Cliente · Cargar tarjeta',
  '/cliente/tienda': 'Cliente · Tienda',
  '/cliente/nueva-suscripcion': 'Cliente · Nueva suscripción',
  '/cliente/pagar-pedido': 'Cliente · Pagar pedido',

  // ─── Admin (panel.limpack.uy/admin/*) ───────────────────────────
  '/admin': 'Admin · Dashboard',
  '/admin/entregas': 'Admin · Entregas',
  '/admin/mi-ruta': 'Admin · Mi ruta',
  '/admin/clientes': 'Admin · Clientes',
  '/admin/clientes/suscriptores': 'Admin · Suscriptores',
  '/admin/clientes/fuera-zona': 'Admin · Clientes fuera zona',
  '/admin/cobros': 'Admin · Cobros',
  '/admin/cobros-mp': 'Admin · Cobros MP',
  '/admin/cobros-pendientes': 'Admin · Cobros pendientes',
  '/admin/configuracion-bancaria': 'Admin · Config bancaria',
  '/admin/pedidos': 'Admin · Pedidos',
  '/admin/pedidos-b2b': 'Admin · Pedidos B2B',
  '/admin/barrios': 'Admin · Barrios',
  '/admin/logistica/limpackflex': 'Admin · LimpackFlex',
  '/admin/logistica/despachos': 'Admin · Despachos interior',
  '/admin/recordatorios': 'Admin · Recordatorios',
  '/admin/etiquetas': 'Admin · Etiquetas',
  '/admin/armado': 'Admin · Armado',
  '/admin/stock': 'Admin · Stock',
  '/admin/kits': 'Admin · Kits',
  '/admin/tienda': 'Admin · Tienda',
  '/admin/auditoria-kits': 'Admin · Auditoría kits',
  '/admin/materiales': 'Admin · Materiales',
  '/admin/proveedores': 'Admin · Proveedores',
  '/admin/orden-compra': 'Admin · Órdenes de compra',
  '/admin/usuarios': 'Admin · Usuarios',
  '/admin/repartidores': 'Admin · Repartidores',
  '/admin/reportes': 'Admin · Reportes',
  '/admin/reportes/modelo-financiero': 'Admin · Modelo financiero',
  '/admin/finanzas': 'Admin · Finanzas',
  '/admin/finanzas/reportes': 'Admin · Finanzas · Reportes',
  '/admin/finanzas/gastos-fijos': 'Admin · Gastos fijos',
  '/admin/finanzas/plan-cuentas': 'Admin · Plan de cuentas',
  '/admin/finanzas/tipos-cambio': 'Admin · Tipos de cambio',
  '/admin/finanzas/asientos': 'Admin · Asientos',
  '/admin/finanzas/comisiones-handy': 'Admin · Comisiones Handy',
  '/admin/finanzas/conciliacion': 'Admin · Conciliación',
  '/admin/finanzas/pagos-proveedores': 'Admin · Pagos proveedores',
  '/admin/finanzas/sueldos': 'Admin · Sueldos',
  '/admin/finanzas/centros-costo': 'Admin · Centros de costo',
  '/admin/finanzas/activos-fijos': 'Admin · Activos fijos',
  '/admin/facturacion': 'Admin · Facturación (CFE)',
  '/admin/porteros': 'Admin · Porteros',
  '/admin/consultas-comerciales': 'Admin · Consultas comerciales',
  '/admin/porteros/postulaciones': 'Admin · Postulaciones porteros',
  '/vendedor': 'Panel del aliado',
  '/admin/vendedores': 'Admin · Aliados',
  '/admin/crm': 'Admin · CRM',
  '/admin/crm-mobile': 'Admin · CRM mobile',
  '/admin/canales/mercadolibre': 'Admin · Canal ML',
  '/admin/canales/mercadolibre/preguntas': 'Admin · ML · Preguntas',
  '/admin/canales/mercadolibre/eventos': 'Admin · ML · Eventos',
  '/admin/canales/mercadolibre/configuracion': 'Admin · ML · Configuración',
  '/admin/analytics/trafico': 'Admin · Analytics tráfico',
  '/admin/monitor-externo': 'Admin · Monitor externo',
  '/admin/alertas-sistema': 'Admin · Alertas sistema',
  '/admin/infraestructura': 'Admin · Infraestructura',
  '/admin/integraciones': 'Admin · Integraciones',
  '/admin/docs': 'Admin · Docs',
  '/admin/qa': 'Admin · QA',
  '/admin/marketing': 'Admin · Marketing hub',
  '/admin/audiencias': 'Admin · Audiencias',
  '/admin/meta-ads': 'Admin · Meta Ads',
}

// ============================================================================
// Rutas dinámicas (con patrones)
// El :param queda en la etiqueta para que Nico vea qué recurso concreto.
// ============================================================================
const RUTAS_DINAMICAS = [
  { re: /^\/admin\/clientes\/([^/]+)$/,          label: (m) => `Admin · Cliente #${m[1].slice(0, 8)}` },
  { re: /^\/admin\/usuarios\/([^/]+)$/,          label: (m) => `Admin · Usuario #${m[1].slice(0, 8)}` },
  { re: /^\/admin\/repartidores\/([^/]+)$/,      label: (m) => `Admin · Repartidor #${m[1].slice(0, 8)}` },
  { re: /^\/admin\/stock\/([^/]+)$/,             label: (m) => `Admin · Producto ${m[1]}` },
  { re: /^\/admin\/kits\/([^/]+)$/,              label: (m) => `Admin · Kit ${m[1]}` },
  { re: /^\/admin\/pedidos\/([^/]+)$/,           label: (m) => `Admin · Pedido ${m[1]}` },
  { re: /^\/cliente\/suscripcion\/([^/]+)$/,     label: (m) => `Cliente · Suscripción #${m[1].slice(0, 8)}` },
  { re: /^\/cliente\/cargar-tarjeta\/([^/]+)$/,  label: () => 'Cliente · Cargar tarjeta' },
  { re: /^\/d\/([^/]+)$/,                        label: () => 'Tracking entrega (link corto)' },
  { re: /^\/invitar\/([^/]+)$/,                  label: () => 'Invitación con token' },
  // Assets estáticos que aparecen en analytics — los agrupamos
  { re: /^\/assets\/.+\.(png|jpg|jpeg|svg|webp|gif|ico)$/i,      label: () => '📷 Asset imagen' },
  { re: /^\/assets\/.+\.(js|mjs|css)$/i,                          label: () => '📦 Asset JS/CSS' },
  { re: /^\/.+\.(png|jpg|jpeg|svg|webp|gif|ico)$/i,               label: () => '📷 Imagen suelta' },
  { re: /^\/favicon\.(ico|png|svg)$/i,                            label: () => 'Favicon' },
  { re: /^\/manifest\.(json|webmanifest)$/i,                      label: () => 'PWA manifest' },
  { re: /^\/robots\.txt$/i,                                       label: () => 'robots.txt' },
  { re: /^\/sitemap\.xml$/i,                                      label: () => 'sitemap.xml' },
]

/**
 * Devuelve el nombre humano de un path.
 * Si no encuentra match, devuelve el path original (fallback seguro).
 *
 * @param {string} path — ej: '/', '/cliente/mi-plan', '/admin/clientes/abc123'
 * @returns {string}
 */
export function nombrePagina(path) {
  if (!path || typeof path !== 'string') return path || '—'

  // Limpiar query string y hash — analytics agrupa por path base
  const clean = path.split('?')[0].split('#')[0]

  // 1. Match exacto
  if (RUTAS_EXACTAS[clean]) return RUTAS_EXACTAS[clean]

  // 2. Match con patrones dinámicos
  for (const { re, label } of RUTAS_DINAMICAS) {
    const m = clean.match(re)
    if (m) return label(m)
  }

  // 3. Fallback: devolver el path tal cual (mejor que nada — Nico puede investigar rutas nuevas)
  return clean
}
